import { useCallback } from 'react';
import {
    Button, Card, CardHeader, Collapse,
} from 'reactstrap';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './index.scss';

const defaultCollapseProps = {};

export const ControlledAccordionCollapse = ({
    secondaryAction = null,
    title,
    children,
    open,
    setOpen,
    CollapseProps = defaultCollapseProps,
    className = '',
    closedIcon = faChevronDown,
    openIcon = faChevronUp,
}) => {
    const handleToggle = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();

        setOpen(!open);
    }, [open, setOpen]);

    return (
        <Card className={`accordion-card${open ? ' open' : ''}${className ? ` ${className}` : ''}`}>
            <CardHeader
                className="d-flex flex-row justify-content-between align-items-center"
            >
                <Button
                    color="link"
                    onClick={handleToggle}
                    className="p-0 text-left f-fill"
                    size="sm"
                    aria-expanded={open}
                >
                    <FontAwesomeIcon
                        className="mr-1"
                        icon={
                            !open
                                ? closedIcon
                                : openIcon
                        }
                        title={
                            open
                                ? 'HideDetails'
                                : 'Show Details'
                        }
                    />
                    <strong>{title}</strong>
                </Button>

                {Boolean(secondaryAction) && (
                    <div className="accordion-secondary-action">
                        {secondaryAction}
                    </div>
                )}
            </CardHeader>

            <Collapse
                isOpen={open}
                {...open ? CollapseProps : {}}
            >
                {children}
            </Collapse>
        </Card>
    );
};